/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Icon } from 'semantic-ui-react';
import classNames from 'classnames';

import css from './Recording.less';

function Recording({ patientAlreadyJoined, recording }) {
  const [starting, setStarting] = useState(true);
  const [showText, setShowText] = useState(true);

  const handleClick = () => {
    setShowText(true);
    setTimeout(() => {
      setShowText(false);
    }, 3000);
  };

  useEffect(() => {
    if (patientAlreadyJoined) setStarting(false);
  }, [patientAlreadyJoined]);

  useEffect(() => {
    if (!starting)
      setTimeout(() => {
        setShowText(false);
      }, 3000);
  }, [starting]);

  if (!recording) return null;

  return (
    <div
      className={classNames(css.container, 'recording')}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyUp={() => {}}>
      {!starting ? (
        <div className={css.buttonWrap}>
          <div className={css.button} />
        </div>
      ) : (
        <Icon loading name="spinner" />
      )}
      <div className={classNames(css.text, { [css.textFade]: !starting && !showText })}>
        {!starting ? 'Audio recording' : 'Recording will start soon'}
      </div>
    </div>
  );
}

export default Recording;
